import { apiClient } from 'api'
import { GameLinkType } from 'types/game-link-type'

export const getGameLinkTypes = () => apiClient.get<GameLinkType[]>(`/game-link-types`)
